export interface DateRange {
  start_date: string;
  end_date: string;
  notes?: string;
}

// Ported from the legacy distinctDateRange validator: sort by start, then a list
// overlaps if any range's end is at or after the next range's start.
export const hasOverlap = (ranges: DateRange[]): boolean => {
  const sorted = [...ranges].sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
  for (let i = 0; i < sorted.length - 1; i++) {
    if (new Date(sorted[i].end_date).getTime() >= new Date(sorted[i + 1].start_date).getTime()) {
      return true;
    }
  }
  return false;
};

// Returns the list with `range` appended (index null) or replaced at `index`.
export const withRange = (ranges: DateRange[], range: DateRange, index: number | null): DateRange[] => {
  if (index == null) return [...ranges, range];
  return ranges.map((existing, i) => (i === index ? range : existing));
};
